"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormats = void 0;
exports.TimeFormats = {
    dateTime: "YYYYMMDD[T]HHmmss",
    dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
    allDay: "YYYYMMDD",
};
//# sourceMappingURL=utils.js.map